const st = typeof localStorage === 'object' ? localStorage : {};

export const keys = {
  user: '__amondz_admin_user__',
};

const storage = {
  set(key, value) {
    st[key] = value;
  },
  get(key) {
    if (!st[key]) return null;
    try {
      const value = st[key];
      return value;
    } catch (e) {
      st.clear();
      return null;
    }
  },
  remove(key) {
    delete st[key];
  },
  clear() {
    if (st.clear) {
      st.clear();
    }
  },
};

export default storage;
